function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1 11.485a9.042 9.042 0 018.56-9L7.824 1.412A.492.492 0 018.34.575l3.279 2.021a.492.492 0 01.109.746l-2.295 2.57a.492.492 0 11-.733-.655l1.607-1.8h-.258a8.033 8.033 0 108.066 8.033 8.489 8.489 0 00-3.588-6.855.491.491 0 11.552-.813 9.5 9.5 0 014.021 7.663 9.05 9.05 0 01-18.1 0z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.984 15.735l-3.267-3.92a.489.489 0 01-.119-.244v-.01a.478.478 0 01-.007-.085v-4.58a.492.492 0 01.984 0v4.408l3.164 3.8a.491.491 0 11-.755.629z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M0 .502h20v20H0z"
});

var SvgPostpone = function SvgPostpone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      viewBox: "0 0 20 21",
      width: 20,
      height: 21,
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3, _ref4)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgPostpone, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/Postpone.057b8f3e.svg";
export { ForwardRef as ReactComponent };